import { jsx as _jsx } from "react/jsx-runtime";
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import { SuiteTile } from './SuiteTile';
import { borderStyle, StyledCardGrid, SuiteStarterCardGrid } from './MerchCardSharedComponents';
import { FREE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import SuiteFreeTile from './SuiteFreeTile';
import { useSelector } from 'react-redux';
import { isStarterGWP2023EligibleSelector } from '../../selectors/PromotionSelectors';
import { isProGWP2023EligibleSelector } from '../../selectors/PromotionSelectors';
export const SuiteTiles = ({
  selectedTab,
  isSuiteStarterPage
}) => {
  const productLevelsToShow = getMerchCardsToShow({
    tab: selectedTab,
    isSuiteStarterPage
  });
  const isStarterGWP = useSelector(isStarterGWP2023EligibleSelector);
  const isProGWP = useSelector(isProGWP2023EligibleSelector);
  const GridComponent = isSuiteStarterPage ? SuiteStarterCardGrid : StyledCardGrid;
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 28,
      paddingRight: 28,
      borderRight: borderStyle,
      borderLeft: borderStyle
    };
    const disclaimer = productLevel === STARTER && isStarterGWP ? `pricingPage.promotions.starterGWPDisclaimer` : productLevel === PROFESSIONAL && isProGWP ? 'pricingPage.promotions.proGWPDisclaimer' : undefined;

    if (FREE === productLevel) {
      return /*#__PURE__*/_jsx(SuiteFreeTile, {
        commonStyles: commonStyles,
        isSuiteStarterPage: isSuiteStarterPage
      }, productLevel);
    }

    return /*#__PURE__*/_jsx(SuiteTile, {
      productLevel: productLevel,
      commonStyles: commonStyles,
      disclaimer: disclaimer,
      isSuiteStarterPage: isSuiteStarterPage
    }, productLevel);
  });
  return /*#__PURE__*/_jsx("div", {
    className: "flex-column align-center justify-center",
    children: /*#__PURE__*/_jsx(GridComponent, {
      columns: productLevelsToShow.length,
      children: suiteCardComponents
    })
  });
};